import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'

import {
  Field,
  SimpleTextField,
  TextField,
  SelectField,
  validators,
  Switch,
} from 'discada/dist/Form'

import Button from 'discada/dist/Button'

import {
  getUser,
  getErrorsFor,
  getFindingUser,
  getFoundUser,
} from 'selectors/appStatusSelectors'
import {
  saveUser,
  deleteUser,
  getUserByEmail,
  clearUserSearch,
} from 'actions/appStatusActions'

import './EditUserForm.scss'

export class UserForm extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      user: this.props.user || {},
      showFullForm: this.props.showFullForm,
      foundUser: this.props.foundUser,
    }

    this.onChange = (key, proc = v => v) => ({ target }) =>
      this.setState({ user: { ...this.state.user, [key]: proc(target.value) } })

    this.togglePref = key => () => {
      let user = this.state.user

      this.setState({
        user: {
          ...user,
          preferences: {
            ...user.preferences,
            [key]: !get(user, `preferences[${key}]`),
          },
        },
      })
    }

    this.nameValidator = () => {
      let { user } = this.state,
        { firstName, lastName } = user,
        a = validators.alpha,
        firstOk = !firstName || a(firstName),
        lastOk = !lastName || a(lastName)

      if (firstOk && lastOk) return false

      return 'Please, enter a valid name'
    }
  }

  static getDerivedStateFromProps(newProps, oldState) {
    let user = !isEmpty(oldState.user) ? oldState.user : newProps.user,
      foundUser = newProps.foundUser

    return { user: { ...foundUser, ...user } }
  }

  componentWillUnmount() {
    this.props.clearUserSearch()
  }

  render() {
    let {
        id,
        className,
        onCancel = () => {},
        errors,
        showFullForm,
        saveUser,
        deleteUser,
        isFindingUser,
        getUserByEmail,
      } = this.props,
      { user } = this.state,
      notValidEmail = !validators.email(get(user, 'email', ''))

    return (
      <div className={c('user-edit-form', className)}>
        <h1>{id ? 'Edit' : 'Add'} User</h1>

        <TextField
          label="Email"
          validateFor="email"
          leftIcon="envelope"
          value={get(user, 'email', '')}
          onChange={this.onChange('email')}
          error={errors.email}
          disabled={showFullForm}
        />

        {!showFullForm && (
          <Button
            success
            loading={isFindingUser}
            disabled={notValidEmail}
            onClick={() => getUserByEmail(get(user, 'email', ''))}
          >
            Continue
          </Button>
        )}

        {showFullForm && (
          <div className="user-form-complete">
            <Field label="Name" error={errors.name || this.nameValidator()}>
              {fieldProps => (
                <React.Fragment>
                  <div className="field">
                    <SimpleTextField
                      {...fieldProps}
                      placeholder="First Name"
                      leftIcon="user"
                      value={get(user, 'firstName', '')}
                      onChange={this.onChange('firstName')}
                    />
                  </div>
                  <div className="field">
                    <SimpleTextField
                      {...fieldProps}
                      placeholder="Last Name"
                      leftIcon="user"
                      value={get(user, 'lastName', '')}
                      onChange={this.onChange('lastName')}
                    />
                  </div>
                </React.Fragment>
              )}
            </Field>

            <TextField
              label="Cell Phone"
              leftIcon="mobile-alt"
              value={get(user, 'phone', '')}
              onChange={this.onChange('phone')}
              error={errors.phone}
              validateFor="phone"
            />

            <SelectField
              label="Role"
              value={get(user, 'roles[0]', 'ft.managed/public')}
              onChange={this.onChange('roles', v => [v])}
            >
              <option value="ft.managed/rooftop-admin">
                Underboss (Admin)
              </option>
              <option value="ft.managed/sales-manager">
                Caporegime (Sales Manager)
              </option>
              <option value="ft.managed/sales-agent">
                Soldier (Sales Agent)
              </option>
              <option value="ft.managed/bdc-agent">
                Associate (BDC Agent)
              </option>
              <option value="ft.managed/public">
                Civilian (No Permissions)
              </option>
            </SelectField>

            <div className="field-group">
              <Switch
                value={get(user, 'preferences.reports')}
                success
                rounded
                labelSide="right"
                label="Daily Rooftop Activity Email Report"
                onChange={this.togglePref('reports')}
              />
              <Switch
                value={get(user, 'preferences.weeklyReports')}
                success
                rounded
                labelSide="right"
                label="Weekly Rooftop Activity Email Report"
                onChange={this.togglePref('weeklyReports')}
              />
              <Switch
                value={get(user, 'preferences.monthlyReports')}
                success
                rounded
                labelSide="right"
                label="Monthly Rooftop Activity Email Report"
                onChange={this.togglePref('monthlyReports')}
              />
              <Switch
                value={get(user, 'preferences.phone')}
                success
                rounded
                labelSide="right"
                label="Known Lead Activity SMS Alerts"
                onChange={this.togglePref('phone')}
              />
              <Switch
                value={get(user, 'preferences.email')}
                success
                rounded
                labelSide="right"
                label="Emails when a Lead becomes Known"
                onChange={this.togglePref('email')}
              />
            </div>

            <Field className="submit-set">
              <Button success onClick={() => saveUser(user) && onCancel()}>
                {id ? 'Update' : 'Add'}
              </Button>
              <Button text onClick={onCancel}>
                Cancel
              </Button>
            </Field>

            {id && (
              <Field>
                <Button danger onClick={() => deleteUser(user.id)}>
                  Delete User
                </Button>
              </Field>
            )}
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let foundUser = getFoundUser(state)

  return {
    ...op,
    user: { ...foundUser, ...getUser(state, op.id) },
    errors: getErrorsFor(state, 'userConfig'),
    showFullForm: !!op.id || foundUser !== null,
    isFindingUser: getFindingUser(state),
    foundUser,
  }
}

export default connect(
  mapStateToProps,
  { saveUser, deleteUser, getUserByEmail, clearUserSearch },
)(UserForm)
